import Vue from "vue";
import Vuex from "vuex";
import { auth } from "@/store/modules/auth";
import { current } from "@/store/modules/current";
import { distributor } from "@/store/modules/distributor";
import { fickle } from "@/store/modules/fickle";
import { version } from "@/store/modules/version";
import { routes } from "@/store/modules/routes";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    version,
    current,
    routes,
    distributor,
    fickle,
  },

  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["leaflet"],
    }),
  ],
});
